export const isLogLevelName = (val) => {
    if (['trace', 'debug', 'info', 'warn', 'error'].includes(val)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=convertStringToLogLevelName.js.map